import React, { useState, useEffect } from 'react';
import ScrollContainer from "react-indiana-drag-scroll";
import Paginator from '../../shared/Paginator';
import NoDataFound from '../../shared/NoDataFound';
import { alphaformatDateTime } from "../../utils/dateFormat";
import TableLoader from '../../shared/TableLoader';
import { Toast } from '../../shared/Toast';
import api from "../../services/api";
import Modal from './components/Modal';  // Import the Modal component
import config from '../../config';
import { renderLocationDetails, renderSalesPersonCell } from '../Designer/utils/cellRenderers';


const ProgressAds = ({Designs,setDesigns,loader,setloader,handleWriteContentClick,totalprogress,currentPage,setCurrentPage,handlePageChange}) =>{
  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const [modalContent, setModalContent] = useState(''); 
  const closeModal = () => {
    setShowModal(false);
    setModalContent('');  // Reset modal content on close
  };

  const openModal = (content) => {
    setModalContent(content);
    setShowModal(true);
  };
  return(
    <div>
      <ScrollContainer>
        <table className="table table-bordered">
          <thead>
            <tr className="bg-gray-100">
              <th className="p-2 text-left">Sales Person Details</th>
              <th>Campaign Name</th>
              <th>Location Details</th>
              <th>Ad Type</th>
              <th>Adops</th>
              <th>Assign Time</th>
              <th>Reference</th>
              <th>Action</th>
            </tr>
          </thead>
          {(Designs.length > 0 && !loader) ? (
            Designs.map((row, idx) => {
              const assign_time = alphaformatDateTime(row.assigndate);
              return (
                <tbody key={idx}>
                  <tr className="border-t">
                    <td>{renderSalesPersonCell(row.sales_person,row)}</td>
                    <td>{row.creative_name}</td>
                    <td>{renderLocationDetails(row)}</td>
                    <td>{row.ad_creative_sub_type}</td>
                    <td>{row.cst_name}</td>
                    <td className="font-bold">
                      <div>{assign_time.dateStr}</div>
                      <div className="text-xs text-gray-500">{assign_time.timeStr}</div>
                    </td>
                    <td>
                      <button
                        className="bg-blue-600 text-white px-3 py-1 rounded"
                        onClick={() => openModal(JSON.parse(row.content_rough_description))}
                      >
                        Show Rough Description
                      </button>
                    </td>
                    <td>
                      <button
                        className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 transition-colors"
                        onClick={() => handleWriteContentClick(row, 1)}
                      >
                        Write Content
                      </button>
                    </td>
                  </tr>
                </tbody>
              );
            })
          ) : (!Designs.length && !loader) ? (
            <NoDataFound colspan="12" />
          ) : (
            <TableLoader colspan="12" />
          )}
        </table>
      </ScrollContainer>
      <Modal show={showModal} onClose={closeModal} content={modalContent} />
      <div className="flex justify-end">
        {Math.ceil(totalprogress / config.PER_PAGE)  > 1 && (
          <Paginator
            pageCount={Math.ceil(totalprogress / config.PER_PAGE)}
            handlePageClick={handlePageChange}
            forcePage={currentPage}
          />)
        }
      </div>
    </div>
  );
};

export default ProgressAds;
